module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [_c('link-generator', {
    ref: "generator"
  }), _vm._v(" "), _c('base-editor', {
    ref: "editor",
    attrs: {
      "value": _vm.contentFullHtml
    },
    on: {
      "input": _vm.onInput,
      "click": _vm.onContentClick,
      "keydown": _vm.onKeyDown
    }
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "pre-content"
    },
    slot: "pre-content"
  }, [_c('div', {
    staticClass: "udc"
  }, [_vm._v("\n        УДК 000\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "footer",
    attrs: {
      "slot": "post-content"
    },
    slot: "post-content"
  }, [_vm._t("lit-list")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37a1d82e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleView.vue
// module id = 1004
// module chunks = 1